/**
 * Display formatters. Montants are integer-centimes on the wire (finance convention) — never floats.
 * Numerics render in a mono LTR island so they stay readable under dir="rtl".
 */

/** centimes (int) → "1 234,50 DA". Pure formatting; the wire value stays an int. */
export function formatMontant(centimes: number | null | undefined): string {
  const n = typeof centimes === "number" ? centimes : 0;
  const da = n / 100;
  const s = da.toLocaleString("fr-DZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${s} DA`;
}

/** Parse a "1234,50" / "1234.50" DA input back to integer centimes. NaN-safe (returns null). */
export function parseMontantToCentimes(input: string): number | null {
  const cleaned = input.replace(/\s/g, "").replace(",", ".");
  if (cleaned === "") return null;
  const da = Number(cleaned);
  if (!Number.isFinite(da) || da < 0) return null;
  return Math.round(da * 100);
}

/** ISO date string → "12/03/1990" (fr). Empty-safe. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("fr-DZ", { year: "numeric", month: "2-digit", day: "2-digit" });
}

const SEXE_LABEL: Record<string, string> = { m: "M", f: "F", i: "I" };
export function formatSexe(sexe: string): string {
  return SEXE_LABEL[sexe] ?? sexe;
}
